const defaultLogger = console;

export { defaultLogger };
//# sourceMappingURL=logger.mjs.map
